import { useTRPC } from '@/trpc';
import { useMutation } from '@tanstack/react-query';
import { AlertDialog, AlertDialogTrigger, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel } from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import React from 'react'
import * as Icon from 'lucide-react'
import { toast } from 'sonner';
import { TRPCClientError } from '@trpc/client';

interface Props {
    task_id: string;
    trigger?: React.ReactNode;
    onRemoved?: () => void;
}

const RemoveTask = ({ task_id, trigger, onRemoved }: Props) => {
    const { trpc } = useTRPC();
    const [open, setOpen] = React.useState(false);

    interface RemoveTaskData {
        task_id: string;
    }
    const removeMutation = useMutation({
        mutationFn: async (data:RemoveTaskData) => {
            await trpc.tasks.remove.mutate(data)
        },
        onSuccess: () => {
            onRemoved?.();
            setOpen(false);
        },
        onError: (err) => {
            if(err instanceof Error) {
                toast.error(err.message);
            } else if(err instanceof TRPCClientError) {
                toast.error(err.message);
            } else {
                toast.error("Er is een onbekende fout opgetreden.");
            }
        }
    })

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>
        <AlertDialogContent>
            <AlertDialogHeader>
                <AlertDialogTitle>Verwijder taak</AlertDialogTitle>
                <AlertDialogDescription>Weet je zeker dat je deze taak wilt verwijderen?</AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
                <AlertDialogCancel>Annuleren</AlertDialogCancel>
                <Button
                    variant='destructive'
                    onClick={()=>{removeMutation.mutate({task_id})}}
                    disabled={removeMutation.isLoading}
                >
                    {removeMutation.isLoading && <Icon.Loader2 className="w-4 h-4 animate-spin" />}
                    Verwijderen
                </Button>
            </AlertDialogFooter>
        </AlertDialogContent>
    </AlertDialog>
  )
}

export default RemoveTask